// 消息模板变量

// icon字体
export const icon_fontSize = 30;

// icon 背景颜色
export const icon_bgColor = "red";

// notice自动关闭时间
export const notice_duration = 30;

export const onClose = () => {};
